import type { TripSegmentType } from '../../../models';
import type { BookingNumberForVerification } from './models';

export const getFlightsForVerification = (
  tripSegments: NonNullable<TripSegmentType>[],
): Record<string, BookingNumberForVerification> => {
  return tripSegments.reduce((acc: Record<string, BookingNumberForVerification>, segment) => {
    const { carrierBookingNumber } = segment;
    const bookingNumber = segment.carrierBookingNumber?.bookingNumber;
    if (carrierBookingNumber && bookingNumber) {
      if (!acc[bookingNumber]) {
        acc[bookingNumber] = {
          carrierBookingNumber,
          virtualCard: segment.virtualCard,
          flights: [],
        };
      }

      acc[bookingNumber].flights.push({
        flightNumber: segment.flightNumber,
        origin: segment.origin,
        destination: segment.destination,
      });
    }
    return acc;
  }, {});
};
